enum CategoryStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export default CategoryStatus;
